module.exports = "/_next/static/images/ourPartnersLogo5-9864368dd0e0f72e29ac0937443bcf0f.webp";